import RatingDisplay from './RatingDisplay'

export default RatingDisplay
